<div class="sidebar-container">
  <div class="sidebar-brand">
    <img
      src="https://cdn-cloudschool.cssapps.net/images/csPoweredLogo.png"
      alt="Cloud Smart School"
      class="brand-logo"
    />
  </div>

  <nav class="sidebar-nav">
    <mat-nav-list>

      <!-- Dashboard -->
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active-link">
        <span class="nav-item-content">
          <mat-icon>dashboard</mat-icon>
          <span>Dashboard</span>
        </span>
      </a>

      <!-- Chapter / Subject Setup — non-Cloud Campus only -->
      @if (!isCloudCampus()) {
        <mat-expansion-panel class="nav-expansion">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>folder_open</mat-icon>
              <span>Chapter Setup</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a mat-list-item routerLink="/chapter-setup/add-chapter" routerLinkActive="active-link">
            <span class="nav-item-content child">
              <mat-icon>add</mat-icon>
              <span>Add Chapter</span>
            </span>
          </a>
          <a mat-list-item routerLink="/chapter-setup/chapter-list" routerLinkActive="active-link">
            <span class="nav-item-content child">
              <mat-icon>list</mat-icon>
              <span>Chapter List</span>
            </span>
          </a>
        </mat-expansion-panel>
      }

      <!-- Question Manager -->
      <mat-expansion-panel class="nav-expansion">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>help_outline</mat-icon>
            <span>Question Manager</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <a mat-list-item routerLink="/question-manager/add-question" routerLinkActive="active-link">
          <span class="nav-item-content child">
            <mat-icon>add</mat-icon>
            <span>Add Question</span>
          </span>
        </a>
        <a mat-list-item routerLink="/question-manager/questions" routerLinkActive="active-link">
          <span class="nav-item-content child">
            <mat-icon>list</mat-icon>
            <span>Question List</span>
          </span>
        </a>
      </mat-expansion-panel>

      <!-- Exam Manager -->
      <mat-expansion-panel class="nav-expansion">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>assignment</mat-icon>
            <span>Exam Manager</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <a mat-list-item routerLink="/exam-manager/add-exam" routerLinkActive="active-link">
          <span class="nav-item-content child">
            <mat-icon>add</mat-icon>
            <span>Create Exam</span>
          </span>
        </a>
        <a mat-list-item routerLink="/exam-manager/exam-list" routerLinkActive="active-link">
          <span class="nav-item-content child">
            <mat-icon>list</mat-icon>
            <span>Exam List</span>
          </span>
        </a>
      </mat-expansion-panel>

      <!-- Users — admin only -->
      @if (isAdmin()) {
        <a mat-list-item routerLink="/users" routerLinkActive="active-link">
          <span class="nav-item-content">
            <mat-icon>manage_accounts</mat-icon>
            <span>Users</span>
          </span>
        </a>
      }

       <!-- Sync Programs & Subjects — Cloud Campus only -->
      @if (isCloudCampus()) {
        <a mat-list-item routerLink="/sync-programs-subjects" routerLinkActive="active-link">
          <span class="nav-item-content">
            <mat-icon>sync</mat-icon>
            <span>Programs & Subjects</span>
          </span>
        </a>
      }

      <!-- System Settings — admin only -->
      @if (isAdmin()) {
        <a mat-list-item routerLink="/system-settings" routerLinkActive="active-link">
          <span class="nav-item-content">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </span>
        </a>
      }

    </mat-nav-list>
  </nav>
</div>
